import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  listItems: [],

  activeItem: {},
  loading: false,
  activeItemloading: false,
};
export const getAttitudeToRiskRatingsListItems = createAsyncThunk(
  "attitudeToRiskRatings/getAttitudeToRiskRatingsListItems",
  async (_, { rejectWithValue }) => {
    try {
      const response: any =
        await apiServices.systemManager.attitudeToRiskRating.getList();
      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getAttitudeToRiskRatingDetailById = createAsyncThunk(
  "attitudeToRiskRatings/getAttitudeToRiskRatingDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid Id ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.attitudeToRiskRatings.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.id === Id);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const attitudeToRiskRatingsSlice = createSlice({
  name: "attitudeToRiskRatings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAttitudeToRiskRatingsListItems.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(getAttitudeToRiskRatingsListItems.fulfilled, (state, action) => {
        state.loading = false;
        state.listItems = action.payload;
      })
      .addCase(getAttitudeToRiskRatingsListItems.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getAttitudeToRiskRatingDetailById.pending, (state) => {
        state.activeItemloading = true;
        state.activeItem = {};
      })
      .addCase(getAttitudeToRiskRatingDetailById.fulfilled, (state, action) => {
        state.activeItemloading = false;
        state.activeItem = action.payload;
      })
      .addCase(getAttitudeToRiskRatingDetailById.rejected, (state, action) => {
        state.activeItemloading = false;
        console.error("Error fetching  details:", action.payload);
      });
  },
});
export const {} = attitudeToRiskRatingsSlice.actions;
export default attitudeToRiskRatingsSlice.reducer;
